import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Typography, Box, CircularProgress, Grid } from "@mui/material";
import Scoreboard from "src/components/versus/Scoreboard";
import { GameScore } from "src/utils/scoreUtils";
import EventsList from "src/components/versus/EventsList";
import { useEffect } from "react";

export default function VersusGameDetailsPage() {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const games = useSelector((state) => state.versusGames.games);
  const gameDetails = games.find(
    (game) => game.versusGameId === parseInt(gameId)
  );

  useEffect(() => {
    if (!gameDetails) {
      navigate(-1);
    }
  }, [gameDetails, navigate]);

  if (!gameDetails) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={24} sx={{ mr: 2 }} />
      </Box>
    );
  }

  const lineupA = gameDetails.gameDetails?.userLineup || [];
  const lineupB = gameDetails.gameDetails?.opponentLineup || [];

  const getScoreboardData = () => {
    if (!gameDetails.gameDetails) return [];

    const userLineup = gameDetails.gameDetails.userLineup || [];
    const opponentLineup = gameDetails.gameDetails.opponentLineup || [];

    return userLineup
      .map((player, index) => ({
        playerA: `${player.firstname || "User"} ${player.lastname || "A"}`,
        scoreA: player.score || 0,
        teamA: player.teamExternalRef || "Team A",
        position: player.position || "Unknown",
        playerB: `${opponentLineup[index]?.firstname || "Opponent"} ${
          opponentLineup[index]?.lastname || "B"
        }`,
        scoreB: opponentLineup[index]?.score || 0,
        teamB: opponentLineup[index]?.teamExternalRef || "Opponent Team",
      }))
      .filter((row) => row.scoreA !== 0 || row.scoreB !== 0);
  };

  const userA = {
    username: gameDetails.username,
    wins: gameDetails.userWins,
    losses: gameDetails.userLosses,
    draws: gameDetails.userDraws || 0,
    rank: gameDetails.userRank || "N/A",
  };

  const userB = {
    username: gameDetails.opponentUsername,
    wins: gameDetails.opponentWins || 0,
    losses: gameDetails.opponentLosses || 0,
  };

  const events = gameDetails.gameDetails?.events || [];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Versus Game Details
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={8}>
          <GameScore
            lineupA={lineupA}
            lineupB={lineupB}
            userA={userA}
            userB={userB}
          />

          <Scoreboard data={getScoreboardData()} userA={userA} userB={userB} />
        </Grid>

        <Grid item xs={4}>
          <Box sx={{ mt: 3 }}>
            <Typography variant="h5" gutterBottom>
              Game Events
            </Typography>
            <EventsList events={events} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
